// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Atom_Divider from "../../atom/Atom_Divider.bs.js";
import * as Particle_Background_Ds from "../../particle/Particle_Background_Ds.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";
import * as Molecule_BurgerMenuIcon_Ds from "../../molecule/Molecule_BurgerMenuIcon_Ds.bs.js";

var corporate_background = Particle_Background_Ds.Corporate.menu;

function corporate_ctaStyle(state) {
  return {
          TAG: /* Corporate */3,
          _0: {
            TAG: /* MenuItem */1,
            _0: state
          }
        };
}

function corporate_ctaChildStyle(highlight) {
  return {
          TAG: /* Corporate */3,
          _0: {
            TAG: /* MenuItemChild */3,
            _0: highlight
          }
        };
}

function corporate_ctaWithChildsStyle(state, highlight) {
  return {
          TAG: /* Corporate */3,
          _0: {
            TAG: /* MenuItemWithChilds */2,
            _0: state,
            _1: highlight
          }
        };
}

var corporate_dividerStyle = Atom_Divider.corporateMenu;

function corporate_searchCtaStyle(state) {
  return {
          TAG: /* Corporate */3,
          _0: {
            TAG: /* SearchButton */4,
            _0: state
          }
        };
}

var corporate = {
  background: corporate_background,
  brandTitleStyle: undefined,
  burgerStyle: Molecule_BurgerMenuIcon_Ds.corporate,
  ctaStyle: corporate_ctaStyle,
  ctaChildStyle: corporate_ctaChildStyle,
  ctaHighlightStyle: undefined,
  ctaWithChildsStyle: corporate_ctaWithChildsStyle,
  dividerStyle: corporate_dividerStyle,
  justifyContent: Particle_Screen_Constants.justifyContentCenter,
  searchCtaStyle: corporate_searchCtaStyle,
  searchFormBackground: Particle_Background_Ds.white,
  searchFormStyle: /* CorporateMenuSearch */0
};

var presse_background = Particle_Background_Ds.Presse.menu;

var presse_brandTitleStyle = {
  TAG: /* Presse */16,
  _0: /* MenuBrandTitle */2
};

function presse_ctaStyle(state) {
  return {
          TAG: /* Presse */16,
          _0: {
            TAG: /* MenuItem */0,
            _0: state
          }
        };
}

function presse_ctaChildStyle(highlight) {
  return {
          TAG: /* Presse */16,
          _0: {
            TAG: /* MenuItemChild */1,
            _0: highlight
          }
        };
}

var presse_ctaHighlightStyle = {
  TAG: /* Presse */16,
  _0: /* MenuItemHightlight */3
};

function presse_ctaWithChildsStyle(state, highlight) {
  return {
          TAG: /* Presse */16,
          _0: {
            TAG: /* MenuItemWithChilds */2,
            _0: state,
            _1: highlight
          }
        };
}

function presse_searchCtaStyle(state) {
  return {
          TAG: /* Presse */16,
          _0: {
            TAG: /* SearchButton */4,
            _0: state
          }
        };
}

var presse_searchFormBackground = Particle_Background_Ds.Presse.menu;

var presse = {
  background: presse_background,
  brandTitleStyle: presse_brandTitleStyle,
  burgerStyle: Molecule_BurgerMenuIcon_Ds.presse,
  ctaStyle: presse_ctaStyle,
  ctaChildStyle: presse_ctaChildStyle,
  ctaHighlightStyle: presse_ctaHighlightStyle,
  ctaWithChildsStyle: presse_ctaWithChildsStyle,
  dividerStyle: undefined,
  justifyContent: Particle_Screen_Constants.justifyContentCenter,
  searchCtaStyle: presse_searchCtaStyle,
  searchFormBackground: presse_searchFormBackground,
  searchFormStyle: /* PresseMenuSearch */1
};

function view(param) {
  return {
          background: param.background,
          burgerStyle: param.burgerStyle,
          brandTitleStyle: param.brandTitleStyle,
          ctaStyle: param.ctaStyle,
          ctaChildStyle: param.ctaChildStyle,
          ctaHighlightStyle: param.ctaHighlightStyle,
          ctaWithChildsStyle: param.ctaWithChildsStyle,
          dividerStyle: param.dividerStyle,
          justifyContent: param.justifyContent,
          searchCtaStyle: param.searchCtaStyle,
          searchFormBackground: param.searchFormBackground,
          searchFormStyle: param.searchFormStyle
        };
}

export {
  corporate ,
  presse ,
  view ,
}
/* Atom_Divider Not a pure module */
